import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetJurisdictionResourcesQueryVariables = Types.Exact<{
  jurisdictionId: Types.Scalars['uuid']['input'];
}>;


export type GetJurisdictionResourcesQuery = { __typename?: 'query_root', jurisdiction_resources: Array<{ __typename?: 'jurisdiction_resources', id: any, jurisdiction_id: any, name: string, description?: string | null, file_name: string, file_url: string, mime_type: string, file_size_bytes?: any | null, created_at: any }> };


export const GetJurisdictionResourcesDocument = gql`
    query getJurisdictionResources($jurisdictionId: uuid!) {
  jurisdiction_resources(
    where: {jurisdiction_id: {_eq: $jurisdictionId}}
    order_by: {created_at: desc}
  ) {
    id
    jurisdiction_id
    name
    description
    file_name
    file_url
    mime_type
    file_size_bytes
    created_at
  }
}
    `;

/**
 * __useGetJurisdictionResourcesQuery__
 *
 * To run a query within a React component, call `useGetJurisdictionResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJurisdictionResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJurisdictionResourcesQuery({
 *   variables: {
 *      jurisdictionId: // value for 'jurisdictionId'
 *   },
 * });
 */
export function useGetJurisdictionResourcesQuery(baseOptions: Apollo.QueryHookOptions<GetJurisdictionResourcesQuery, GetJurisdictionResourcesQueryVariables> & ({ variables: GetJurisdictionResourcesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJurisdictionResourcesQuery, GetJurisdictionResourcesQueryVariables>(GetJurisdictionResourcesDocument, options);
      }
export function useGetJurisdictionResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJurisdictionResourcesQuery, GetJurisdictionResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJurisdictionResourcesQuery, GetJurisdictionResourcesQueryVariables>(GetJurisdictionResourcesDocument, options);
        }
export function useGetJurisdictionResourcesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetJurisdictionResourcesQuery, GetJurisdictionResourcesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetJurisdictionResourcesQuery, GetJurisdictionResourcesQueryVariables>(GetJurisdictionResourcesDocument, options);
        }
export type GetJurisdictionResourcesQueryHookResult = ReturnType<typeof useGetJurisdictionResourcesQuery>;
export type GetJurisdictionResourcesLazyQueryHookResult = ReturnType<typeof useGetJurisdictionResourcesLazyQuery>;
export type GetJurisdictionResourcesSuspenseQueryHookResult = ReturnType<typeof useGetJurisdictionResourcesSuspenseQuery>;
export type GetJurisdictionResourcesQueryResult = Apollo.QueryResult<GetJurisdictionResourcesQuery, GetJurisdictionResourcesQueryVariables>;